// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__1boST","container":"Options_container__2cVIP","title":"Options_title__ZUTEH","content":"Options_content__1xryW","subtitle":"Options_subtitle__1d73B"};